import React, { useCallback } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import FileErrorPreviewPdf from 'components/Dropzone/FileErrorPreviewPdf';
import PdfDocument from 'components/PdfViewer/PdfDocument';
import SecuredImage from 'components/SecuredImage';
import { quality } from 'utils/constants';

/**
 * PdfPreview
 */
const PdfPreview = ({
  changeLoader,
  elementDimension,
  entityType,
  file,
  fullViewer,
  moduleId,
  onError = () => null,
  onPageLoadSuccess,
  onPageLoadError,
  overflow,
  pins = [],
  onPlacePin,
  renderPageNumber,
  zonesData,
  addZoomButton,
  mouseWheelZoom,
  seeAnnotations,
  isFirstPageOnly,
  updatePin,
  fileType,
  plan,
  hasOfferLimitation = false,
  tools = {
    annotationVisibilityOptionEnabled: false,
    itemsVisibilityOptionEnabled: false,
    annotationAreVisible: false,
    itemsAreVisible: false,
    toggleAnnotationVisibility: () => null,
    toggleItemsVisibility: () => null,
  },
  document,
}) => {
  const renderError = useCallback(
    () => {
      onError();
      return (
        <Box sx={{ textAlign: 'center' }}>
          <FileErrorPreviewPdf />
        </Box>
      );
    },
    [onError],
  );

  return (
    <SecuredImage
      forceRefresh
      componentSrc="file"
      withPlaceholder={false}
      imgQuality={quality.original}
    >
      <PdfDocument
        addZoomButton={addZoomButton}
        mouseWheelZoom={mouseWheelZoom}
        overflow={overflow}
        fullViewer={fullViewer}
        changeLoader={changeLoader}
        zonesData={zonesData}
        file={file}
        onError={renderError}
        scale={elementDimension?.scale}
        renderPageNumber={renderPageNumber}
        originalWidth={elementDimension?.originalWidth}
        originalHeight={elementDimension?.originalHeight}
        onPageLoadSuccess={onPageLoadSuccess}
        onPageLoadError={onPageLoadError}
        pins={pins}
        onPlacePin={onPlacePin}
        moduleId={moduleId}
        entityType={entityType}
        seeAnnotations={seeAnnotations}
        isFirstPageOnly={isFirstPageOnly}
        updatePin={updatePin}
        fileType={fileType}
        plan={plan}
        hasOfferLimitation={hasOfferLimitation}
        tools={tools}
        document={document}
      />
    </SecuredImage>
  );
};

PdfPreview.propTypes = {
  file: PropTypes.string,
  addZoomButton: PropTypes.bool,
  mouseWheelZoom: PropTypes.bool,
  zonesData: PropTypes.object,
  elementDimension: PropTypes.object,
  renderPageNumber: PropTypes.number,
  onPageLoadSuccess: PropTypes.func,
  onPageLoadError: PropTypes.func,
  changeLoader: PropTypes.func,
  onError: PropTypes.func,
  overflow: PropTypes.bool,
  fullViewer: PropTypes.bool,
  pins: PropTypes.array,
  onPlacePin: PropTypes.func,
  moduleId: PropTypes.string,
  entityType: PropTypes.string,
  seeAnnotations: PropTypes.bool,
  isFirstPageOnly: PropTypes.bool,
  updatePin: PropTypes.func,
  fileType: PropTypes.string,
  plan: PropTypes.object,
  hasOfferLimitation: PropTypes.bool,
  document: PropTypes.object,
  tools: PropTypes.shape({
    annotationVisibilityOptionEnabled: PropTypes.bool,
    itemsVisibilityOptionEnabled: PropTypes.bool,
    annotationAreVisible: PropTypes.bool,
    itemsAreVisible: PropTypes.bool,
    toggleAnnotationVisibility: PropTypes.func,
    toggleItemsVisibility: PropTypes.func,
  }),
};

export default PdfPreview;
